import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Paper,
  TablePagination,
  Button,
  Popover,
  TextField,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import { useState } from "react";
import { addInvite } from "../network_requests";
import Alert from "@material-ui/lab/Alert";

export default function InvitedPeopleTable(props) {
  const rows = props.rows;
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [load, setLoad] = useState(false);
  const [success, setSuccess] = useState(false);
  const [name, setName] = useState("");
  const [inviteKey, setInviteKey] = useState("");

  return (
    <>
      <TableContainer component={Paper}>
        <Table size="small" style={{ tableLayout: "fixed" }} stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell align="right">Invitation_code</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => (
                <TableRow key={row.name}>
                  <TableCell>{row.Person_Name}</TableCell>
                  <TableCell align="right">{row.Invitation_code}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
        <TableRow>
          <TableCell>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
              colSpan={3}
              count={rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={(event, page_) => {
                setPage(page_);
              }}
              onChangeRowsPerPage={(event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
              }}
            />
          </TableCell>
          <TableCell align="right">
            {props.add_user === "Accepted" ? (
              <Button
                variant="outlined"
                style={{
                  backgroundColor: "#438DD2",
                  color: "#FAFAFA",
                  marginRight: "5px",
                }}
                onClick={(event) => {
                  setAnchorEl(event.currentTarget);
                }}
              >
                New Invite
              </Button>
            ) : null}
          </TableCell>
        </TableRow>
      </TableContainer>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null);
        }}
        style={{ maxWidth: "70%" }}
      >
        <div style={{ padding: "10px" }}>
          <Typography>Enter name:</Typography>
          <TextField
            variant="outlined"
            size="small"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
          ></TextField>

          {load ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                paddingTop: "10px",
              }}
            >
              <CircularProgress />
            </div>
          ) : null}
          {success ? (
            <Alert severity="success" fullWidth>
              Key: {inviteKey}
            </Alert>
          ) : (
            <Button
              variant="outlined"
              fullWidth
              size="small"
              disabled={load}
              style={{
                backgroundColor: "#438DD2",
                color: "#FAFAFA",
                marginRight: "5px",
                marginTop: "10px",
              }}
              onClick={async (event) => {
                setLoad(true);
                const key = await addInvite(name);
                if (key) {
                  rows.push({
                    Invitation_code: key,
                    Person_Name: name,
                  });
                }
                setInviteKey(key);
                setName("");
                setLoad(false);
                setSuccess(true);
                setTimeout(() => {
                  setSuccess(false);
                  setAnchorEl(null);
                }, 10000);
              }}
            >
              Invite
            </Button>
          )}
        </div>
      </Popover>
    </>
  );
}
